module.exports = __webpack_public_path__ + "img/ac89aca.svg";